"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _get = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var HTMLElementImpl = require("./HTMLElement-impl").implementation;

var notImplemented = require("../../browser/not-implemented");

var idlUtils = require("../generated/utils");

var _require = require("../../utils"),
    Canvas = _require.Canvas;

var HTMLCanvasElementImpl = /*#__PURE__*/function (_HTMLElementImpl) {
  _inherits(HTMLCanvasElementImpl, _HTMLElementImpl);

  var _super = _createSuper(HTMLCanvasElementImpl);

  function HTMLCanvasElementImpl() {
    _classCallCheck(this, HTMLCanvasElementImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLCanvasElementImpl, [{
    key: "_attrModified",
    value: function _attrModified(name, value) {
      if (this._canvas && (name === "width" || name === "height")) {
        this._canvas[name] = parseInt(value);
      }

      return _get(_getPrototypeOf(HTMLCanvasElementImpl.prototype), "_attrModified", this).apply(this, arguments);
    }
  }, {
    key: "_getCanvas",
    value: function _getCanvas() {
      if (Canvas && !this._canvas) {
        this._canvas = new Canvas(this.width, this.height);
      }

      return this._canvas;
    }
  }, {
    key: "getContext",
    value: function getContext(contextId) {
      var canvas = this._getCanvas();

      if (canvas) {
        if (!this._context) {
          this._context = canvas.getContext(contextId) || null;

          if (this._context) {
            // Override the native canvas reference with our wrapper. This is the
            // reason why we need to locally cache _context, since each call to
            // canvas.getContext(contextId) would replace this reference again.
            // Perhaps in the longer term, a better solution would be to create a
            // full wrapper for the Context object as well.
            this._context.canvas = idlUtils.wrapperForImpl(this);
            wrapNodeCanvasMethod(this._context, "createPattern");
            wrapNodeCanvasMethod(this._context, "drawImage");
          }
        }

        return this._context;
      }

      notImplemented("HTMLCanvasElement.prototype.getContext (without installing the canvas npm package)", this._ownerDocument._defaultView);
      return null;
    }
  }, {
    key: "toDataURL",
    value: function toDataURL() {
      var canvas = this._getCanvas();

      if (canvas) {
        return canvas.toDataURL.apply(this._canvas, arguments);
      }

      notImplemented("HTMLCanvasElement.prototype.toDataURL (without installing the canvas npm package)", this._ownerDocument._defaultView);
      return null;
    }
  }, {
    key: "toBlob",
    value: function toBlob(callback, type, qualityArgument) {
      var window = this._ownerDocument._defaultView;

      var canvas = this._getCanvas();

      if (canvas) {
        var stream;

        switch (type) {
          case "image/jpg":
          case "image/jpeg":
            stream = canvas.createJPEGStream({
              quality: Math.max(0, Math.min(1, qualityArgument)) * 100
            });
            break;

          default:
            // TODO: Patch node-canvas to receive qualityArgument for PNG stream
            type = "image/png";
            stream = canvas.createPNGStream();
        }

        var buffers = [];
        stream.on("data", function (chunk) {
          buffers.push(chunk);
        });
        stream.on("end", function () {
          callback(new window.Blob(buffers, {
            type: type
          }));
        });
      } else {
        notImplemented("HTMLCanvasElement.prototype.toBlob (without installing the canvas npm package)", window);
      }
    }
  }, {
    key: "width",
    get: function get() {
      var parsed = parseInt(this.getAttribute("width"));
      return isNaN(parsed) || parsed < 0 || parsed > 2147483647 ? 300 : parsed;
    },
    set: function set(v) {
      v = v > 2147483647 ? 300 : v;
      this.setAttribute("width", String(v));
    }
  }, {
    key: "height",
    get: function get() {
      var parsed = parseInt(this.getAttribute("height"));
      return isNaN(parsed) || parsed < 0 || parsed > 2147483647 ? 150 : parsed;
    },
    set: function set(v) {
      v = v > 2147483647 ? 150 : v;
      this.setAttribute("height", String(v));
    }
  }]);

  return HTMLCanvasElementImpl;
}(HTMLElementImpl); // We need to wrap the methods that receive an image or canvas object
// (luckily, always as the first argument), so that these objects can be
// unwrapped an the expected types passed.


function wrapNodeCanvasMethod(ctx, name) {
  var prev = ctx[name];

  ctx[name] = function (image) {
    var impl = idlUtils.implForWrapper(image);

    if (impl) {
      arguments[0] = impl._image || impl._canvas;
    }

    return prev.apply(ctx, arguments);
  };
}

module.exports = {
  implementation: HTMLCanvasElementImpl
};